import React from 'react';

import { SimpleDrawer, TableView } from '../../core-ui';
import { Link } from '../Navigation';
import { RecipientStatusBadge } from './RecipientStatusBadge';
import { GetJobSummary_job_recipients as Recipient } from './__generated__/GetJobSummary';

export default function RecipientsDialog(props: {
  isOpen: boolean;
  recipients: Array<Recipient>;
  onClosePress: () => void;
}) {
  const { isOpen, onClosePress, recipients } = props;

  return (
    <SimpleDrawer
      drawerTitle={t('{count} Recipient(s)', { count: recipients.length })}
      isOpen={isOpen}
      onClose={onClosePress}
      size="xl"
      returnFocusOnClose={false}
      bodyProps={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        paddingBottom: 6,
      }}
    >
      <TableView
        data={recipients}
        columns={[
          {
            title: t('Name'),
            render: (recipient) => recipient.name,
            tdProps: { overflow: 'hidden', overflowWrap: 'break-word' },
          },
          {
            title: t('Email'),
            render: (recipient) => recipient.email,
            tdProps: { overflow: 'hidden', overflowWrap: 'break-word' },
          },
          {
            title: t('Status'),
            render: (recipient) => (
              <RecipientStatusBadge status={recipient.status} />
            ),
            tdProps: { overflow: 'hidden', overflowWrap: 'break-word' },
          },
          {
            title: '',
            render: (recipient) => (
              <Link
                to={['/vendors/:id', { id: recipient.vendor }]}
                variant="blue"
              >
                {t('Details')}
              </Link>
            ),
            tdProps: { width: '1%', cursor: 'default' },
            onClick: (event) => event.stopPropagation(),
          },
        ]}
      />
    </SimpleDrawer>
  );
}
